import { render, staticRenderFns } from "./WaitingTime.vue?vue&type=template&id=5bae5f40&"
import script from "./WaitingTime.vue?vue&type=script&lang=ts&"
export * from "./WaitingTime.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingTime.vue?vue&type=style&index=0&id=5bae5f40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports